export const getAbilityName = segment => {
  if (segment === 1) {
    return "Objetivos de aprendizagem e desenvolvimento";
  }

  return "Habilidade";
};

export const getDisciplineName = segment => {
  if (segment === 1) {
    return "Campo de experiência";
  }

  return "Componente curricular";
};

export const getDisciplines = (segment, disciplines) => {
  if (segment === 1) {
    return disciplines; // .filter(discipline => discipline.learning_area_name === "Ensino Infantil");
  }

  return disciplines.filter(
    discipline => discipline.learning_area_name !== "Ensino Infantil"
  );
};
